// src/utils/localCart.js
const LOCAL_CART_KEY = 'pending_enquiry_items'

export const getLocalCart = () => {
  const raw = localStorage.getItem(LOCAL_CART_KEY)
  return raw ? JSON.parse(raw) : []
}

export const saveLocalCart = (items) => {
  localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(items))
}

export const addToLocalCart = (productId, customText, imageUrl, categoryName, productName) => {
  const items = getLocalCart()
  const exists = items.some(item => item.ProductID === productId)
  if (exists) return false
  items.push({
    localId: Date.now() + Math.random(),
    ProductID: productId,
    image: imageUrl,
    category: categoryName,
    name: productName,
    customizationText: customText || ''
  })
  saveLocalCart(items)
  return true
}

export const removeFromLocalCart = (localId) => {
  let items = getLocalCart()
  items = items.filter(item => item.localId !== localId)
  saveLocalCart(items)
}

export const updateLocalCartCustomization = (localId, text) => {
  let items = getLocalCart()
  const target = items.find(item => item.localId === localId)
  if (target) target.customizationText = text
  saveLocalCart(items)
}

export const clearLocalCart = () => {
  localStorage.removeItem(LOCAL_CART_KEY)
}